import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const kafkaTopicPickerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'kafka-topic-picker-form-field-extension',
    params: {
      field: () =>
        import('./kafka-topic-picker').then(m => m.KafkaTopicPickerFormField),
    },
  });
